<template>
    <div>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-if="isDesktop()" class="mt-5" style="margin-bottom:10%">
            <v-container style="padding-right:25px!important;padding-bottom:25px!important;padding-left:15px!important">
                <v-flex pt-4>
                    <v-toolbar dark flat color="rgba(255,164,9,0.8)" justify-content-center row>
                        <v-toolbar-title class=" text-center ml-5 pl-5">
                            <img src="../assets/img/pictos/credit-card.png" alt="Devis Sante" width="10%">
                            <span style="font-size: 25px" class="georgia"> Numéro Devis : {{Devis_pour_souscription.numeroDevis}}</span>
                        </v-toolbar-title>
                    </v-toolbar>
                </v-flex>

                <v-flex xs12 pb-3 justify-content-center
                        class="row wrap-content elevation-0 row-container mt-5 ml-1 border grey lighten-3 border-radius">
                    <!--logo Assureur et Notation étoilée-->
                    <v-flex xs4 sm2 class="pt-4  ml-5" justify-content-center column>
                        <img :src="this.$store.state.devispayementDiffere.result.partenaire.logo" width="130"
                             height="100" alt="partenaire logo">
                        <p class="font-weight-black pl-5">
                            {{this.$store.state.devispayementDiffere.result.partenaire.societe}}</p>
                    </v-flex>

                    <!--Tarifs-->
                    <v-flex xs4 pt-5 justify-content-center row>
                        <ul class="List-cout pl-5">
                            <li>
                                <p class="font-weight-bold text-center" style="font-size:25px;color:#ffa409">
                                    {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                                    <small>FCFA</small>
                                </p>
                            </li>
                            <span class="font-weight-black title justify-center row georgia">Prime totale</span>
                            <p>
                                <small class="title font-weight-light justify-center row georgia">(Frais de dossier
                                    inclus)</small>
                            </p>
                        </ul>
                    </v-flex>

                    <!--bouttons ...-->
                    <v-flex xs4 mt-4 class="right--texting">
                        <ul class="list-boutons">
                            <li>
                                <v-btn small color="default" class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe0cf;</i>Être
                                    Rappelé
                                </v-btn>
                            </li>

                            <li>
                                <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                                </v-btn>
                            </li>

                            <li>
                                <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe2c4;</i>
                                    Telecharger
                                </v-btn>
                            </li>
                        </ul>
                    </v-flex>
                </v-flex>

                <v-flex row justify-content-center v-if="showPaymentBLock==false">
                    <v-btn round @click="show=true" color="#ffa409"
                           class="font-weight-bold text-white georgia mb-2 mt-2">Souscrire
                    </v-btn>
                </v-flex>
                <!--=========== PARTIE DETAILS ET PAIEMENT ============-->
                <!--=========== PARTIE DETAILS ET PAIEMENT ============-->
                <v-flex v-show="showPaymentBLock==true">
                    <v-flex xs12 pb-3 justify-content-center
                            class="row block-content elevation-0 row-container mt-3 ml-1 border grey lighten-3 border-radius">
                        <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                            <p class="font-weight-black headline georgia">Détails de la couverture</p>
                        </v-flex>

                        <v-flex justify-content-center xs11 sm10 md11 lg11
                                class="row block-content elevation-0 row-container bg-transparent ">
                            <v-flex xs12 sm12 md12 lg12
                                    class="table-responsive row block-content elevation-0 row-container bg-transparent ">
                                <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                                    <thead class="bg-light georgia">
                                    <tr>
                                        <th class="head">Objet(s) couvert(s</th>
                                        <th class="head">Pack(s) souscrit(s)</th>
                                        <th class="head">Autres informations</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <!--============================================Details Assurance cas Automobile WEB===================================================-->
                                        <td>
                                            <ul class="to-left mb-3 georgia" style="width:100%">
                                                <li class="font-weight-regular subheading">Catégorie client : <span
                                                        class="to-right georgia">{{this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis[0].groupe_ou_individuel}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading">Branche : <span
                                                        class="to-right georgia">{{this.$store.state.devispayementDiffere.La_branche}}</span>
                                                </li>
                                            </ul>
                                        </td>
                                        <!--============================================Liste Garanties si c'est devis Auto===================================================-->
                                        <td>
                                            <ul class="to-left georgia" style="width:100%;margin-bottom: -10%">
                                                <li class="font-weight-regular subheading">Pack(s) :</li>
                                            </ul>

                                            <ul class="to-left mb-1 georgia" style="width:100%"
                                                v-for="(g, index) in tab_pack" :key="index">
                                                <li class="font-weight-regular subheading">
                                                    <span class="to-right font-weight-bold georgia">{{g.nompack}}</span>
                                                </li>
                                            </ul>

                                            <ul class="to-left mb-3 georgia" style="width:100%">
                                                <li class="font-weight-regular subheading"> Période :<span
                                                        class="to-right font-weight-bold georgia">{{this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis[0].periode}}</span>
                                                </li>
                                            </ul>
                                        </td>

                                        <!--============================================Autres informations===================================================-->
                                        <td>
                                            <ul class="to-left mb-3 georgia" style="width:100%">
                                                <li class="font-weight-regular subheading"> Date D'effet :<span
                                                        class="to-right"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date D'echeance :<span
                                                        class="to-right"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Partenaire :<span
                                                        class="to-right font-weight-bold georgia">{{this.$store.state.devispayementDiffere.result.partenaire.societe}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date de souscription : <span
                                                        class="to-right"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </v-flex>
                        </v-flex>

                        <v-flex justify-content-center xs11 sm10 md11 lg11
                                class="row block-content elevation-0 row-container bg-transparent ">
                            <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                                <thead class="bg-light georgia">
                                <tr>
                                    <th class="head">Genre</th>
                                    <th class="head">Prénom</th>
                                    <th class="head">Nom</th>
                                    <th class="head">Téléphone</th>
                                    <th class="head">Adresse</th>
                                    <th class="head">CNI ou Passeport</th>
                                    <th class="head">Nationalité</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tab_perso" :key="item">
                                <tr>
                                    <td class="font-weight-regular subheading border">{{item.genre}}</td>
                                    <td class="font-weight-regular subheading border">{{item.prenom}}</td>
                                    <td class="font-weight-regular subheading border">{{item.nom}}</td>
                                    <td class="font-weight-regular subheading border">{{item.telephone}}</td>
                                    <td class="font-weight-regular subheading border">{{item.adresse}}</td>
                                    <td class="font-weight-regular subheading border">{{item.numero_cni}}</td>
                                    <td class="font-weight-regular subheading border">{{item.pays}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-flex>

                    <v-flex row wrap justify-content-center xs12 pb-3 pt-3 ml-1 v-show="showPaymentBLock==true"
                            class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius">
                        <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                            <p class="font-weight-black headline georgia">Checkout</p>
                        </v-flex>

                        <v-card width="500" class="border-radius">
                            <v-toolbar card color="#ffa409" dark>
                                <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                            </v-toolbar>
                            <div class="col pl-2">
                                <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresseLivre = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Reseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </div>
                        </v-card>

                        <v-card width="500" class="ml-5 border-radius">
                            <v-toolbar card color="#ffa409" dark>
                                <v-toolbar-title class="georgia">Mode de Paiement</v-toolbar-title>
                            </v-toolbar>
                            <div class="col pl-2">
                                <v-radio-group full-width v-model="mode_payement" class="answer georgia">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>
                                </v-radio-group>
                            </div>
                        </v-card>

                        <v-flex xs12 mt-2 justify-content-center row class="bg-transparent" v-show="mode_livraison"
                                v-if="isDesktop()">
                            <span class="font-weight-black h2"> TTC : <span class="red--text">{{mention_ttc.toLocaleString()}}</span> <small> FCFA</small></span>
                        </v-flex>

                        <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                            <v-btn dark color="#ffa409" @click="payement_end()"
                                   class="text-white georgia col-sm-3 border-radius" style="height:40px">Payer
                            </v-btn>
                        </v-flex>
                    </v-flex>
                </v-flex>

                <v-dialog v-model="show" persistent>
                    <v-card elevation="24" class="border-radius">
                        <v-toolbar card color="#ffa409">
                            <span class="font-weight-black title georgia" style="color:#fff">
                                <v-icon color="#fff">&#xe92d;</v-icon>
                                    Informations bénéficiaire(s) 
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show=false" class="float-lg-right" style="color:#fff">
                                <v-icon>&#xe5cd;</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-flex class="border-radius grey lighten-3 column justify-content-center text-center mt-3 ml-3 mr-3">
                            <v-flex>
                                <v-form class="text-center row">
                                    <v-container class="text-center row mt-3 mb-3">
                                        <v-layout ml-3 mr-3 pt-3 class="justify-content-center">
                                            <v-flex xs12 md4>
                                                <v-radio-group class="justify-content-center row" v-model="genre" row>
                                                    <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                                    <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                                </v-radio-group>
                                            </v-flex>

                                            <v-flex class="row mr-1">
                                                <v-text-field class="ml-2" v-model="prenom" prepend-inner-icon="person"
                                                              label="Prénom*" required
                                                              hint="Votre prénom complet"></v-text-field>
                                                <v-text-field class="ml-2" v-model="nom" prepend-inner-icon="person"
                                                              label="Nom*" required
                                                              hint="Votre nom complet"></v-text-field>
                                                <v-text-field @keypress="onlyNumber" class="ml-2" v-model="telephone"
                                                              prepen-inner-icon="phone" label="Téléphone*" required
                                                              type="number"
                                                              hint="Votre numéro de téléphone"></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout ml-3 mr-3 pt-1 class="justify-content-center">
                                            <v-flex class="row">
                                                <v-text-field v-model="adresse" prepend-inner-icon="map"
                                                              label="Adresse*" required
                                                              hint="Votre adresse actuelle*"></v-text-field>
                                                <v-text-field class="ml-2" v-model="numero_cni"
                                                              prepend-inner-icon="person" label="CNI ou Passeport*"
                                                              required type="text"
                                                              hint="Numéro CNI ou numéro Passeport"></v-text-field>

                                                <v-flex style="margin-top:-15px">
                                                    <label for=""> Nationalité* </label>
                                                    <select solo v-model="pays"
                                                            class="border selectatDesktop col-md-11  pt-3">
                                                        <option v-for="itm in countries" :key="itm.PAYS"
                                                                :value="itm.PAYS">
                                                            {{itm.PAYS}}
                                                        </option>
                                                    </select>

                                                </v-flex>

                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-form>

                                <v-flex class="row">
                                    <div class="col-sm-12 text-center">
                                        <v-btn class="font-weight-bold text-white georgia" round color="#ffa409"
                                               @click="Detail_info_beneficiaires">Ajouter
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-flex>
                        </v-flex>

                        <v-flex xs12 ml-5 mr-5 mt-3>
                            <table class="table table-simple text-center">
                                <thead class="bg-light">
                                <tr>
                                    <th>Genre</th>
                                    <th>Prénom</th>
                                    <th>Nom</th>
                                    <th>Téléphone</th>
                                    <th>Adresse</th>
                                    <th>CNI ou Passeport</th>
                                    <th>Nationalité</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tab_perso" :key="item">
                                <tr>
                                    <td class="border">{{item.genre}}</td>
                                    <td class="border">{{item.prenom}}</td>
                                    <td class="border">{{item.nom}}</td>
                                    <td class="border">{{item.telephone}}</td>
                                    <td class="border">{{item.adresse}}</td>
                                    <td class="border">{{item.numero_cni}}</td>
                                    <td class="border">{{item.pays}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>

                        <v-flex class="row" v-if="showValiderBtn">
                            <div class="col-sm-12 text-center">
                                <v-btn class="font-weight-bold text-white georgia" round color="#ffa409"
                                       @click="show=false;showPaymentBLock=true"> Continuer
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-card>
                </v-dialog>
            </v-container>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      ================ -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-if="isMobile()" style="margin-bottom:30%">
            <v-container
                    style="padding-right:25px!important;padding-bottom:25px!important; padding-left:25px!important">
                <v-flex pt-5>
                    <v-toolbar dark flat color="rgba(255,164,9,0.8)">
                        <v-toolbar-title class="text-center">
                            <img src="../assets/img/pictos/credit-card.png" alt="Devis Sante" width="10%">
                            <span style="font-size: 15px" class="georgia">№ Devis :  {{Devis_pour_souscription.numeroDevis}}</span>
                        </v-toolbar-title>
                    </v-toolbar>
                </v-flex>
                <!--logo Assureur et Notation étoilée-->
                <v-layout column justify-content-center>
                    <v-layout column justify-content-center
                              class="ml-2 mt-3 mb-4 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                        <v-flex justify-content-center class="mt-2" style="text-align: center;">
                            <img :src="this.$store.state.devispayementDiffere.result.partenaire.logo" width="130"
                                 height="100" alt="partenaire logo">
                            <p class="font-weight-black">
                                {{this.$store.state.devispayementDiffere.result.partenaire.societe}}</p>
                        </v-flex>

                        <!--bouttons ...-->
                        <v-flex row wrap xs12 sm10 md11 lg11 pt-2>
                            <v-flex row wrap justify-content-center class="right--texting pl-3">
                                <ul class="list-boutons">
                                    <li>
                                        <v-btn small color="default" class="col-lg-6 col-sm-6 col-md-6 georgia">
                                            <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0cf;</i>Être Rappelé
                                        </v-btn>
                                    </li>

                                    <li>
                                        <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)"
                                               class="col-lg-6 col-sm-6 col-md-6 georgia">
                                            <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                                        </v-btn>
                                    </li>

                                    <li>
                                        <v-btn small color="default"
                                               @click="telecharger_le_devis(Devis_pour_souscription)"
                                               class="col-lg-6 col-sm-6 col-md-6 georgia">
                                            <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe2c4;</i> Telecharger
                                        </v-btn>
                                    </li>
                                </ul>
                            </v-flex>
                            <v-flex xs12 class="pt-4" justify-content-center>
                                <ul class="List-cout">
                                    <li><p class="font-weight-black title justify-content-center row"
                                           style="color:#ffa409">
                                        {{Devis_pour_souscription.prime_ttc.toLocaleString()}}<small
                                            class="ml-1">FCFA</small></p></li>
                                    <span class="font-weight-black title justify-content-center row georgia">Prime totale</span>
                                    <li><p class="justify-content-center row georgia">(Frais de dossier inclus)</p></li>
                                </ul>
                            </v-flex>
                        </v-flex>

                        <v-flex class="ml-1 row justify-content-center" v-if="showPaymentBLock==false">
                            <v-btn round @click="show=true" color="#ffa409" class="text-white georgia row mb-2 mt-2">
                                Souscrire
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout v-show="showPaymentBLock==true" column justify-content-center>
                        <v-layout column justify-content-center
                                  class="ml-2 mb-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                            <v-flex class="justify-content-center row">
                                <span class="ml-2 row font-weight-black headline georgia">Détails de la couverture</span>
                            </v-flex>

                            <v-flex class="row mt-2 georgia" justify-content-center>
                                <v-flex justify-content-center ml-3 row>
                                    <v-card width="330">
                                        <v-toolbar card color="rgb(91, 148, 188)" dark>
                                            <v-toolbar-title class="georgia">Objet(s) couvert(s)</v-toolbar-title>
                                        </v-toolbar>
                                        <v-item-group>
                                            <ul class="georgia" style="margin-left:-7%">
                                                <li class="font-weight-regular subheading"> Categorie client : <span
                                                        class="to-right-mobile">{{this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis[0].groupe_ou_individuel}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Branche : <span
                                                        class="to-right-mobile">{{this.$store.state.devispayementDiffere.La_branche}}</span>
                                                </li>
                                            </ul>
                                        </v-item-group>
                                    </v-card>
                                </v-flex>

                                <!--==== others informations for the current DEVIS MOBILE===-->
                                <v-flex justify-content-center ml-3 row class="pt-2">
                                    <v-card width="330">
                                        <v-toolbar card color="rgb(91, 148, 188)" dark>
                                            <v-toolbar-title class="georgia">Pack(s) souscrit(s</v-toolbar-title>
                                        </v-toolbar>
                                        <v-item-group>
                                            <ul class="georgia" style="margin-left:-7%">
                                                <li class="font-weight-regular subheading"> Nom du pack :<span
                                                        class="to-right-mobile">{{this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis[0].nompack}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Période :<span
                                                        class="to-right-mobile">{{this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis[0].periode}}</span>
                                                </li>
                                            </ul>
                                        </v-item-group>
                                    </v-card>
                                </v-flex>

                                <!--==== others informations for the current DEVIS MOBILE===-->
                                <v-flex justify-content-center ml-3 row class="pt-2">
                                    <v-card width="330">
                                        <v-toolbar card color="rgb(91, 148, 188)" dark>
                                            <v-toolbar-title class="georgia">Autres informations</v-toolbar-title>
                                        </v-toolbar>
                                        <v-item-group>
                                            <ul class="georgia" style="margin-left:-7%">
                                                <li class="font-weight-regular subheading"> Date D'effet :<span
                                                        class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date D'echeance :<span
                                                        class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Partenaire :<span
                                                        class="to-right-mobile">{{this.$store.state.devispayementDiffere.result.partenaire.societe}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date de souscription : <span
                                                        class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                                </li>
                                            </ul>
                                        </v-item-group>
                                    </v-card>
                                </v-flex>

                                <v-flex justify-content-center ml-3 row class="pt-2">
                                    <table class="table table-simple text-center ml-2 mr-2">
                                        <thead class="bg-light georgia">
                                        <tr>
                                            <th class="head">Prénom</th>
                                            <th class="head">Nom</th>
                                        </tr>
                                        </thead>
                                        <tbody v-for="item in tab_perso" :key="item.prenom">
                                        <tr style="background:#fff">
                                            <td class="font-weight-regular subheading border">{{item.prenom}}</td>
                                            <td class="font-weight-regular subheading border">{{item.nom}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                            </v-flex>
                        </v-layout>

                        <v-flex justify-content-center row class=" ml-2 mr-2 grey lighten-3 border border-radius">
                            <v-flex class="justify-content-center row">
                                <span class="font-weight-black headline georgia">Checkout</span>
                            </v-flex>

                            <v-card width="300" class="border-radius">
                                <v-toolbar card color="#ffa409" dark>
                                    <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="margin-top:-12px">
                                    <ul>
                                        <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                            <v-radio color="#ffa409" class="highlight"
                                                     label="A domicile  (à partir de 1500 FCFA TTC)"
                                                     @change="adresseLivre = true" value="a_docimicile"></v-radio>
                                            <v-radio color="#ffa409" class="highlight"
                                                     label="Réseau partenaire  (500 FCFA TTC)"
                                                     value="reseau_partenaire"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Assur'Store  (gratuit)"
                                                     value="locaux_assuraf"></v-radio>
                                        </v-radio-group>
                                    </ul>
                                </v-item-group>
                            </v-card>

                            <v-card width="300" class="mt-2 border-radius">
                                <v-toolbar card color="#ffa409" dark>
                                    <v-toolbar-title class="georgia">Mode de paiement</v-toolbar-title>
                                </v-toolbar>
                                <v-item-group style="margin-top:-12px">
                                    <ul>
                                        <v-radio-group full-width v-model="mode_payement" class="answer georgia">
                                            <v-radio color="#ffa409" class="highlight" label="Mobile Money"
                                                     value="mobile_money"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                                     value="carte_bancaire"></v-radio>
                                            <v-radio color="#ffa409" class="highlight"
                                                     label="Paiement au retrait Réseau partenaire"
                                                     value="au_retrait"></v-radio>
                                        </v-radio-group>
                                    </ul>
                                </v-item-group>
                            </v-card>

                            <v-flex xs12 justify-content-center row class="bg-transparent" v-show="mode_livraison"
                                    v-if="isMobile()">
                                <span class="font-weight-black h2">
                                    TTC : 
                                    <span class="red--text">
                                        {{mention_ttc.toLocaleString()}}
                                    </span> 
                                    <small> FCFA</small> 
                                </span>
                                <div ref="upay"></div>
                            </v-flex>

                            <div class="row block-content elevation-0 row-container bg-transparent">
                                <v-flex xs8 class="offset-2 pr-5">
                                    <v-btn dark color="#ffa409" @click="payement_end(Devis_pour_souscription)"
                                           class="text-white georgia col-sm-3 border-radius" style="height:40px">Payer
                                    </v-btn>
                                </v-flex>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-dialog v-model="show" persistent>
                        <v-card elevation="24" class="georgia border-radius scroll">
                            <v-toolbar card color="#ffa409">
                                <span class="font-weight-black title" style="color:#fff">
                                    <v-icon color="#fff">&#xe92d;</v-icon>
                                    <span style="font-weight:bold;font-size:14px!important;">Informations bénéficiaire(s)</span>
                                </span>
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="show=false" class="float-lg-right" style="color:#fff">
                                    <v-icon>&#xe5cd;</v-icon>
                                </v-btn>
                            </v-toolbar>

                            <v-flex class="border-radius grey lighten-3 row mt-2 ml-3 mr-3">
                                <v-flex class="ml-3 mr-3">
                                    <v-form>
                                        <v-container class="georgia">
                                            <v-layout column pl-2 pr-2>
                                                <v-flex xs12 md6>
                                                    <v-radio-group class="justify-content-center row" v-model="genre"
                                                                   row>
                                                        <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                                        <v-radio color="#ffa409" label="Monsieur"
                                                                 value="Homme"></v-radio>
                                                    </v-radio-group>
                                                </v-flex>

                                                <v-flex xs12 md6>
                                                    <v-text-field solo height="10" v-model="prenom" label="Prénom*"
                                                                  required hint="Votre nom complet"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md6 class="to-top">
                                                    <v-text-field solo height="10" v-model="nom" label="Nom*" required
                                                                  hint="Votre prénom complet"></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout column pl-2 pr-2>
                                                <v-flex xs12 md6 class="to-top">
                                                    <v-text-field solo height="10" v-model="adresse" label="Adresse*"
                                                                  required
                                                                  hint="Votre adresse actuelle (*)"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md6 class="to-top">
                                                    <v-text-field @keypress="onlyNumber" solo height="10"
                                                                  v-model="telephone" label="Téléphone*" required
                                                                  type="number"
                                                                  hint="Votre numéro de téléphone"></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout column pl-2 pr-2>
                                                <v-flex xs12 md6 class="to-top">
                                                    <v-text-field solo height="10" v-model="numero_cni"
                                                                  label="CNI ou Passeport*" required type="text"
                                                                  hint="Numéro CNI ou numéro Passeport"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md6 class="to-top">
                                                    <label for="" class="ml-1"> Nationalité* </label>
                                                    <select v-model="pays" class="col-md-4 selectatMobile pt-2">
                                                        <option v-for="itm in countries" :key="itm.PAYS"
                                                                :value="itm.PAYS">
                                                            {{itm.PAYS}}
                                                        </option>
                                                    </select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>

                                    <v-flex class="justify-content-center ml-2 row">
                                        <v-btn class="text-white georgia justify-content-center row" round
                                               color="#ffa409" @click="Detail_info_beneficiaires"> Ajouter
                                        </v-btn>
                                    </v-flex>
                                </v-flex>
                            </v-flex>

                            <v-flex class="row text-center ml-3 mr-3 mt-3">
                                <table class="table table-simple text-center">
                                    <thead class="bg-light">
                                    <tr>
                                        <th>Prénom</th>
                                        <th>Nom</th>
                                    </tr>
                                    </thead>
                                    <tbody v-for="item in tab_perso" :key="item">
                                    <tr>
                                        <td class="border">{{item.prenom}}</td>
                                        <td class="border">{{item.nom}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </v-flex>

                            <v-flex class="justify-content-center ml-1 row" v-if="showValiderBtn">
                                <v-btn class="text-white georgia" round color="#ffa409"
                                       @click="show=false;showPaymentBLock=true"> Continuer
                                </v-btn>
                            </v-flex>
                        </v-card>
                    </v-dialog>
                </v-layout>
            </v-container>
        </div>

        <v-dialog v-model="adresseLivre" persistent max-width="500" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-toolbar color="#ffa409">
                    <v-toolbar-title class="georgia text-white"> Choix livraison <span style="font-size: 14px">(Dakar et Banlieue)</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="grey lighten-3">
                    <v-layout class="justify-content-center">
                        <p class="mr-5 mt-2 font-weight-bold georgia">Tarif Normal</p>
                        <p class="ml-3 mt-2 font-weight-bold georgia">Tarif Express</p>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="justify-content-center container">
                            <form class="form cf">
                                <v-flex class="justify-content-center row" style="margin-top:30px">
                                    <section class="ml-2 justify-conten-center row plan cf">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                                       v-model="prix_livraison" @change="showListCity">
                                                <label v-on="on" class="free-label" for="dakar_normal"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">1500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison le jour <br> même si contrat jusque <br> midi sinon lendemain</strong>
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_express"
                                                       value="dakar_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="basic-label col" for="dakar_express"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison dans les 2 heures</strong>
                                            </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>

                                <v-flex class="justify-content-center row" style="margin-top:-25px">
                                    <section class="ml-2 justify-conten-center row row plan cf">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_normal"
                                                       value="banlieue_normal" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="premium-label col" for="banlieue_normal"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_express"
                                                       value="banlieue_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="optimium-label col" for="banlieue_express"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="span font-weight-bold">2500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison dans les 3 heures</strong>
                                            </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>
                            </form>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="ml-5 mr-5">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                                            label="Veuillez selectionner votre quartier" editable item-text="quartier"
                                            item-value="quartier" color="#59595b"></v-overflow-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-text-field class="ml-5 mr-5" prepend-inner-icon="map"
                                      label="Renseigner adresse de livraison "
                                      v-model="adresselivraison"></v-text-field>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-btn round class="font-weight-bold text-white" style="background:red" flat
                               @click="cancelPaiement()"> Annuler
                        </v-btn>
                        <v-btn round class="font-weight-bold text-white" style="background:#ffa409" flat
                               @click="getAdressLivraison"> Valider
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="adresseLivre" persistent max-width="500" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
                <v-toolbar color="#ffa409">
                    <v-toolbar-title class="georgia text-white"> Livraison <span style="font-size: 14px">(Dakar et Banlieue)</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="grey lighten-3">
                    <v-layout class="justify-content-center">
                        <p class="mr-5 mt-2 font-weight-bold georgia">Tarif Normal</p>
                        <p class="ml-3 mt-2 font-weight-bold georgia">Tarif Express</p>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="justify-content-center container">
                            <form class="form cf">
                                <v-flex class="justify-content-center row" style="margin-top:30px">
                                    <section class="ml-2 justify-conten-center row plan cf">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                                       v-model="prix_livraison" @change="showListCity">
                                                <label v-on="on" class="free-label" for="dakar_normal"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">1500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison le jour <br> même si contrat jusque <br> midi sinon lendemain</strong>
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_express"
                                                       value="dakar_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="basic-label col" for="dakar_express"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison dans les 2 heures</strong>
                                            </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>

                                <v-flex class="justify-content-center row" style="margin-top:-25px">
                                    <section class="ml-2 justify-conten-center row row plan cf">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_normal"
                                                       value="banlieue_normal" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="premium-label col" for="banlieue_normal"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_express"
                                                       value="banlieue_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="optimium-label col" for="banlieue_express"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="span font-weight-bold">2500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison dans les 3 heures</strong>
                                            </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>
                            </form>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="ml-4 mr-4">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                                            label="Veuillez selectionner votre quartier" item-text="quartier"
                                            item-value="quartier" color="#59595b"></v-overflow-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-text-field class="ml-4 mr-4" prepend-inner-icon="map"
                                      label="Renseigner adresse de livraison "
                                      v-model="adresselivraison"></v-text-field>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-btn round class="font-weight-bold text-white" style="background:red" flat
                               @click="cancelPaiement()"> Annuler
                        </v-btn>
                        <v-btn round class="font-weight-bold text-white" style="background:#ffa409" flat
                               @click="getAdressLivraison"> Valider
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">Génération du fichier en cours</span>
    </div>

        <!-- <div class="text-xs-center">
            <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
                <v-card color="orange" dark>
                    <v-card-text>
                        Génération du fichier en cours
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div> -->
    </div>
</template>

<script>
    import Api from '../services/Api'
    import getUpay from './../services/getUpaySante'
    import ville from './../common/ville'

    export default {
        data() {
            return {
                genre: null,
                adresseLivre: false,
                adresselivraison: null,
                myDate: new Date().toISOString().slice(0, 10),
                show: false,
                Devis_pour_souscription: [],
                prix_livraison: null,
                mode_livraison: null,
                mention_ttc: null,
                mode_payement: null,
                dialogRemplissageBeneficiaire: false,
                notifDeviParMail: null,
                notifDeviSendParMail: null,
                dialogLoading: false,
                frais_livraison: null,
                listVille: ville,
                ville: null,
                quartier: '',
                branche: null,
                dialog: false,
                showValiderBtn: false,
                showPaymentBLock: false,
                contratToStore: null,
                maxPersonne: null,
                svgTTC: null,
                notif: null,
                countries: null,
                nom: null,
                prenom: null,
                adresse: null,
                telephone: null,
                numero_cni: null,
                pays: null,
                tab_pack: [],
                itemsGenre: ['Homme', 'Femme'],
                tab_perso: [],

                ToastTabSucess: {
                    // Customized options for success toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 2000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                },
                ToastTabError: {
                    // Customized options for error toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 2000,
                    fitToScreen: true,
                    type: 'error',
                },
            }
        },
        methods: {
            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            cancelPaiement() {
                this.adresseLivre = false;
                this.mode_livraison = null;
                this.adresselivraison = ''
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },
            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

            showListCity() {
                if (this.prix_livraison == 'dakar_normal' || this.prix_livraison == 'dakar_express') {
                    this.dakar = true;
                    this.ville = this.listVille.Dakar;
                    this.quartier = null
                } else if (this.prix_livraison == 'banlieue_normal' || this.prix_livraison == 'banlieue_express') {
                    this.dakar = true;
                    this.ville = this.listVille.Banlieue;
                    this.quartier = null
                }
            },

            Detail_info_beneficiaires() {
                if (this.nom && this.prenom && this.adresse) {
                    if (this.telephone && this.numero_cni && this.pays && this.genre) {
                        let Un_beneficiaire = {
                            nom: this.nom,
                            prenom: this.prenom,
                            adresse: this.adresse,
                            telephone: this.telephone,
                            numero_cni: this.numero_cni,
                            pays: this.pays,
                            genre: this.genre
                        };
                        if (this.tab_perso.length + 1 <= this.maxPersonne) {
                            this.tab_perso.push(Un_beneficiaire);
                            this.$store.dispatch('setListeBeneficiaire', this.tab_perso);
                            this.showValiderBtn = true;
                            this.nom = '';
                            this.prenom = '';
                            this.adresse = '';
                            this.telephone = '';
                            this.numero_cni = ''
                        } else {
                            this.$toasted.show('Le nombre maximum de personnes est atteind ! ', this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                }
            },
            getImgUrl(pic) {
                if (pic) {
                    return pic
                } else {
                    return require('../assets/img/assuraf_sm.png')
                }
            },
            devisParMail: function (params) {
                Api().get('devis/mydevisbyemail/' + params._id)
                    .then(response => {
                        this.notifDeviSendParMail = response.data.info
                    })
            },
            // on envoie les infos du payement au partner dedié si retour == OK on crée un contrat à la suite
            payement_end: function () {
                getUpay(this.mention_ttc, this.mode_payement)
            },
            // Get la liste des pays
            getListePays: function () {
                Api().get('pays')
                    .then(response => {
                        this.countries = response.data
                    })
                    .catch(err => {
                        err
                    })
            },
            getAdressLivraison: function () {
                if (this.prix_livraison) {
                    if (this.prix_livraison == 'dakar_normal') {
                        this.mention_ttc = parseInt(this.svgTTC) + 1500

                    } else if (this.prix_livraison == 'dakar_express') {
                        this.mention_ttc = parseInt(this.svgTTC) + 2000
                    } else if (this.prix_livraison == 'banlieue_normal') {
                        this.mention_ttc = parseInt(this.svgTTC) + 2000
                    } else if (this.prix_livraison == 'banlieue_express') {
                        this.mention_ttc = parseInt(this.svgTTC) + 2500
                    }

                    if (this.adresselivraison && this.quartier) {
                        localStorage.setItem('adressliv', this.adresselivraison);
                        this.adresseLivre = false;
                        (localStorage.getItem('adressLiv'))
                    } else {
                        this.$toasted.show("Adresse de livraison obligatoire ! ", this.ToastTabError)
                    }
                } else {
                    this.$toasted.show("veuillez choisir un mode de livraison ! ", this.ToastTabError)

                }

            },
            // Generation du devis en PDF pour download
            telecharger_le_devis: function (params) {
                Api().get('devis/download/' + params._id)
                    .then(response => {
                        let url = response.data.lien;
                        this.dialogLoading = true;
                        setTimeout(() => (
                            this.dialogLoading = false,
                                window.open(url)), 8000);
                    })
            },
            // Validation des champs du formulaire avant payement
            FormFieldsValidation() {
                if (this.nom && this.prenom && this.adresse && this.telephone && this.numero_cni && this.pays) {
                    return true
                } else {
                    return false
                }
            },
            payementSatrt() {
                this.dialog = true
            },
            //Date object formater to String
            DateFormater: function (TheDate) {
                if (TheDate) {
                    let laDate = new Date(TheDate);
                    let TheDay = laDate.getDate();
                    let TheMonth = laDate.getMonth() + 1;
                    let TheYear = laDate.getFullYear();
                    if (TheMonth < 10 && TheDay < 10) {
                        return TheYear + '-0' + TheMonth + '-0' + TheDay
                    }
                    if (TheMonth > 10 && TheDay < 10) {
                        return TheYear + '-' + TheMonth + '-0' + TheDay
                    }
                    if (TheMonth < 10 && TheDay > 10) {
                        return TheYear + '-0' + TheMonth + '-' + TheDay
                    } else {
                        return TheYear + '-' + TheMonth + '-' + TheDay
                    }
                }
            },
            /* API UPAY ATPS */
            getPay: function () {
                getUpay(this.mention_ttc, this.mode_payement)
            }
        },
        watch: {
            notif: function () {
                if (this.notif == 'Contract created') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else if (this.notif != 'Contract created') {
                    this.$router.push('/payement/failed');
                    this.notif = null
                }
            },
            notifDeviParMail: function () {

                if (this.notifDeviParMail == 'Contrat cree mais non envoye par email') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else if (this.notifDeviParMail == 'Contrat cree et envoye par email') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else {
                    this.$router.push('/payement/failed');
                    this.notif = null
                }
            },
            notifDeviSendParMail: function () {
                if (this.notifDeviSendParMail == 'ok') {
                    this.$toasted.show('Votre devis vous a été envoyé par email !', this.ToastTabSucess)
                }
            },
            mode_livraison: function () {
                if (this.mode_livraison == 'a_docimicile') {
                    this.adresseLivre = true;
                    this.prix_livraison = null
                } else if (this.mode_livraison == 'reseau_partenaire') {
                    this.mention_ttc = this.svgTTC;
                    this.mention_ttc = (parseInt(this.mention_ttc) + 500)
                } else if (this.mode_livraison == 'locaux_assuraf') {
                    this.mention_ttc = this.svgTTC;
                    this.mention_ttc = (parseInt(this.mention_ttc) + 250)
                }
            }
        },
        // Avant la destruction du composant pour charger un autre, on detruit le Devis en store
        beforeDestroy() {
            this.$store.dispatch('setDevisPayementDiffere', null)
        },

        mounted: function () {
            window.scrollTo(0, 0);
            if (this.$store.state.devispayementDiffere.result.devis.numeroDevis && this.$store.state.user) {
                this.getListePays();
                this.mention_ttc = this.$store.state.devispayementDiffere.result.devis.prime_ttc;
                this.svgTTC = this.$store.state.devispayementDiffere.result.devis.prime_ttc;
                this.Devis_pour_souscription = this.$store.state.devispayementDiffere.result.devis;
                this.branche = this.$store.state.devispayementDiffere.result.branche[0].branche;
                this.partenaire = this.$store.state.devispayementDiffere.result.partenaire;
                this.maxPersonne = this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis[0].nb_personne_max;
                this.tab_pack = this.$store.state.devispayementDiffere.result.devis.details_pack_sante.packChoisis
            } else {
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>
    .row-container {
        background: white;
    }

    .container {
        padding: 0px !important;
    }

    .to-top {
        margin-top: -5%
    }

    .to-left {
        text-align: left;
    }

    .to-right {
        float: right;
        margin-right: -36%
    }

    .to-right-mobile {
        float: right;
        margin-right: 2%;
        font-weight: bold
    }

    .to-left span {
        color: black;
        font-weight: bold;

    }

    .List-cout li {
        list-style: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .answer {
        position: relative;
        margin-right: 0;
        float: left;
        display: block;
        margin-right: 2.12766%;
        width: 100%;
    }

    .highlight {
        padding: 6px 12px;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        font-size: .0625rem;
        cursor: pointer;
        color: #6d6d6d;
        border: solid 1px transparent;
        border-bottom: solid 1px #e9e9e9;
        border-radius: 3px;
        transition: background .4s;
    }

    .highlight:hover {
        background-color: rgba(255, 164, 9, 0.3);
        padding-left: 10px;
        transition-duration: 0.5s;
    }

    .head {
        background-color: rgb(91, 148, 188);
        color: white;
        font-size: 18px
    }

    ul li {
        list-style: none;
        padding-top: 7px
    }

    #valeur {
        margin-left: 40%;
    }

    .container {
        padding: 0px !important;
    }

    .uppercase {
        font-weight: bold;
        color: #ffa409;
        text-transform: uppercase;
        font-size: 16px
    }

    .to-left {
        float: right;
        padding-right: 25%
    }

    .to-left-detail {
        float: right;
        padding-right: 5%;
        font-weight: bold;
        color: purple
    }

    .to-left-date {
        float: right;
        padding-right: -5px;
        font-weight: bold;
        color: purple
    }

    .to-right {
        text-align: left;
    }

    .to-left-date-input {
        float: right;
        margin-right: -45px;
        font-weight: bold;
        color: purple
    }

    .selectatMobile {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 95%;
        border-bottom: 1px solid gray;
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 95%;
        border-bottom: 1px solid gray;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .border-radius {
        border-radius: 20px !important
    }


    .form .plan input, .form .payment-plan input, .form .payment-type input {
        display: none;
    }

    .form label {
        margin: 15px;
        width: 130px;
        position: relative;
        color: #333;
        font-family: Georgia !important;
        border-radius: 20px !important;
        background-color: #fff;
        font-size: 15px;
        text-align: center;
        height: 130px;
        display: block;
        cursor: pointer;
        border: 3px solid transparent;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .form .plan input:checked + label, .form .payment-plan input:checked + label, .form .payment-type input:checked + label {
        border-radius: 20px !important;
        background-color: #ffa409;
        color: #fff;

    }

    .form .plan input:checked + label:after, form .payment-plan input:checked + label:after, .form .payment-type input:checked + label:after {
        content: "\2713";
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 100%;
        border: 2px solid #ffa409;
        background-color: #fff;
        color: #ffa409;
        z-index: 999;
        position: absolute;
        top: -10px;
        right: -10px;
    }

    /*================== CSS SELECT GLOBAL AUTO===================*/
    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        box-shadow: none;

        background: #fff;
    }

    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }

    select {
        flex: 1;
        padding: 0 .5em;
        color: grey;
        cursor: pointer;
    }

    /*================== CSS SELECT DESKTOP AUTO===================*/
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 100%;
        height: 3em;
        line-height: 3;
        background: #fff;
        overflow: hidden;
        border: 2px solid #D3D3D3 !important;
        border-radius: 35px;
    }

    /* Arrow */
    .select::after {
        content: '\2228';
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 1em;
        background: #fff;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: .25s all ease;
        -o-transition: .25s all ease;
        transition: .25s all ease;
    }

    /* Transition */
    .select:hover::after {
        color: #f39c12;
    }


.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
